// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__qVnmg","insightsList":"newBusinessInsightsMenu_insightsList__2r0Cn","active":"newBusinessInsightsMenu_active__1X3fy"};